import { create } from "zustand";

export enum ELoginModalState {
  LOGIN = "LOGIN",
  OTP = "OTP",
  REGISTER = "REGISTER",
}

interface LoginModalStore {
  state: ELoginModalState | undefined;
  isOpened: boolean;
  userEmail: string;
  open: (state: ELoginModalState, userEmail?: string) => void;
  close: () => void;
}

const useLoginModalStore = create<LoginModalStore>()((set) => ({
  isOpened: false,
  state: undefined,
  userEmail: "",
  open: (state, userEmail = "") => set({ isOpened: true, state, userEmail }),
  close: () => {
    set({ isOpened: false, state: undefined, userEmail: "" });
  },
}));

export default useLoginModalStore;
